import { render, staticRenderFns } from "./FullnessHistoryComponent.vue?vue&type=template&id=1bfa4022&scoped=true&"
import script from "./FullnessHistoryComponent.vue?vue&type=script&lang=js&"
export * from "./FullnessHistoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./FullnessHistoryComponent.vue?vue&type=style&index=0&id=1bfa4022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa4022",
  null
  
)

export default component.exports